const Hydrometric = {
  inputs: [
    {
      id: 'hydrometric_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد هیدرومتریک',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'add/hydrometric_detail/',
  title: 'ایستگاه هیدرومتریک',
};

const Synoptic = {
  inputs: [
    {
      id: 'synoptic_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سینوپتیک',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'add/synoptic_detail/',
  title: 'سینوپتیک',
};

const DamHumanUsage = {
  inputs: [
    {
      id: 'dam_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
    {
      id: 'dam_item',
      elementConfig: {
        type: 'select',
        placeholder: 'dam_item',
        options: [
          { value: 'real', gainValue: 'real' },
          { value: 'program', gainValue: 'program' },
          { value: 'forecast', gainValue: 'forecast' },
        ],
      },
      indexValue: -1,
      value: '',
      queryParams: true,
    },
  ],
  url: 'add/dam_human_detail/',
  title: 'سد',
};

const DamHumanVolume = {
  inputs: [
    {
      id: 'dam_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سد',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
    {
      id: 'dam_item',
      elementConfig: {
        type: 'select',
        placeholder: 'dam_item',
        options: [
          { value: 'real', gainValue: 'real' },
          { value: 'program', gainValue: 'program' },
          { value: 'forecast', gainValue: 'forecast' },
        ],
      },
      indexValue: -1,
      value: '',
      queryParams: true,
    },
  ],
  url: 'add/dam_human_volume_detail/',
  title: 'حجم سد',
};

const WeatherStation = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
    {
      id: 'weather_item',
      elementConfig: {
        type: 'select',
        placeholder: 'نوع ایستگاه',
        options: [
          { value: 'بارش', gainValue: 'rainfall' },
          { value: 'تبخیر', gainValue: 'evaporation' },
        ],
      },
      indexValue: -1,
      value: '',
      queryParams: true,
    },
  ],
  url: 'add/weather_station_detail/',
  title: 'ایستگاه هواشناسی',
};

const Aquifer = {
  inputs: [
    {
      id: 'aquifer_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد آبخوان',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'add/aquifer_detail/',
  title: 'آبخوان',
};

const Watershed = {
  url: 'add/watershed_detail/',
  title: 'حوضه آبریز',
};

const LakeLevel = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'add/lake_level/',
  title: 'تراز دریاچه',
};

const LakeEvaporation = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'add/lake_evaporation/',
  title: 'تبخیر دریاچه',
};

const Snow = {
  url: 'add/snow_detail/',
  title: 'برف',
};

const Temperature = {
  url: 'add/temperature_detail/',
  title: 'دما',
};

export const uploadTypes = {
  Hydrometric: Hydrometric,
  Synoptic: Synoptic,
  DamHumanUsage: DamHumanUsage,
  DamHumanVolume: DamHumanVolume,
  WeatherStation: WeatherStation,
  Aquifer: Aquifer,
  Watershed: Watershed,
  LakeLevel: LakeLevel,
  LakeEvaporation: LakeEvaporation,
  Snow: Snow,
  Temperature: Temperature,
};

export const uploadTypesTitles = [
  'Hydrometric',
  'Synoptic',
  'DamHumanUsage',
  'DamHumanVolume',
  'WeatherStation',
  'Aquifer',
  'Watershed',
  'LakeLevel',
  'LakeEvaporation',
  'Snow',
  'Temperature',
];
